import { AfterViewInit, Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
declare var cordova: any;

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {


  constructor(private _location: Location) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    
    // if(typeof(cordova) != "undefined"){
    //   window.open = cordova.InAppBrowser.open;
    // }

  }

}


